const rawSiteUrl =
  (typeof process !== 'undefined' && process.env.REACT_APP_SITE_URL) ||
  'https://yogesh-4yrs-portfolio.netlify.app';

export const SITE_URL = rawSiteUrl.replace(/\/$/, '');

export const SITE_NAME = 'Yogesh Singh';

export const DEFAULT_TITLE = `${SITE_NAME} – Frontend Developer | React & Next.js | Gurgaon, India`;

export const DEFAULT_DESCRIPTION =
  'Yogesh Singh is a Frontend Developer in Gurgaon, India with 4+ years of experience in React, Next.js, and JavaScript. Hire a React developer for production web apps, dashboards, and SEO-friendly interfaces.';

export const PERSON = {
  name: 'Yogesh Singh',
  jobTitle: 'Frontend Developer',
  description:
    'Frontend Developer with 4+ years experience in React and Next.js',
  image: SITE_URL
    ? `${SITE_URL}/yogesh-singh-frontend-developer.png`
    : '/yogesh-singh-frontend-developer.png',
  sameAs: [
    'https://www.linkedin.com/in/yogesh1dev',
    'https://github.com/yogeshmlv',
    'https://twitter.com/Yogesh__Dev',
  ],
};
